
import React from 'react'
import { Card, CardBody, Row, Col, Progress } from 'reactstrap'
import {numberWithCommas, toCamel} from '@common/utils'

export default ({ activeTab, data, averageData, parameterDetailByGroup, typeCatagoryName }) => {


    const REAL_TIME_MODE = 1

    const renderStaticCard = (parameterDetail) => {
        const groupDisplay = parameterDetail[0].unitGroup + ' (' + parameterDetail[0].unit + ')'

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>
                        {activeTab === REAL_TIME_MODE ? '' : 'AVG'} {groupDisplay}
                    </h5>
                    <hr />
                    {parameterDetail.map((parameter) => {
                        return (
                            <TextDisplay
                                key={parameter.id}
                                text={parameter.description}
                                value={
                                    activeTab === REAL_TIME_MODE ? (
                                        data && data[toCamel(parameter.parameterName)] || 0
                                    ) : (averageData && averageData[`avg_${parameter.parameterName}`] || 0)
                                }
                                colorStyle={parameter.color}
                            />
                        )
                    })}
                </CardBody>
            </Card>
        )
    }

    const renderPercentageCard = (parameterDetail) => {
        const groupDisplay = parameterDetail[0].unitGroup

        return (
            <Card className="mb-1">
                <CardBody>
                    <h5 className='text-center'>{groupDisplay}</h5>
                    <hr />
                    {parameterDetail.map((parameter) => {
                        return (
                            <ProgressBarDisplay
                                key={parameter.id}
                                text={parameter.description}
                                value={(averageData) ? (Math.round(averageData[`avg_${parameter.parameterName}`] * 100) || ' -') : ' -'}
                                colorStyle={parameter.color}
                            />
                        )

                    })}
                </CardBody>
            </Card>
        )
    }

    return (
        <>
            {parameterDetailByGroup.Temp && renderStaticCard(parameterDetailByGroup.Temp)}
            {parameterDetailByGroup.Status && renderPercentageCard(parameterDetailByGroup.Status)}

            {parameterDetailByGroup.Pressure && renderStaticCard(parameterDetailByGroup.Pressure)}
            {parameterDetailByGroup.Current && renderStaticCard(parameterDetailByGroup.Current)}
            {parameterDetailByGroup.Voltage && renderStaticCard(parameterDetailByGroup.Voltage)}
            {parameterDetailByGroup.Performance && renderStaticCard(parameterDetailByGroup.Performance)}
            {parameterDetailByGroup.Superheat && renderStaticCard(parameterDetailByGroup.Superheat)}
            {parameterDetailByGroup.RPS && renderStaticCard(parameterDetailByGroup.RPS)}
            {parameterDetailByGroup.Power && renderStaticCard(parameterDetailByGroup.Power)}
        </>
    )
}

const TextDisplay = ({ text, value, colorStyle }) => (
    <Row className='text-display'>
        <Col lg='8'>{text}</Col>
        <Col lg='4'>
            <div>
                <span className='text-value' style={{ color: colorStyle }}>
                    {numberWithCommas(value)}
                </span>
            </div>
        </Col>
    </Row>
)

const ProgressBarDisplay = ({ text, value, colorStyle }) => {
    return (
        <div className='status-display'>
            {text} {' : '}
            <span style={{ color: colorStyle, fontWeight: 'bold' }}>
                {value !== ' -' ? (
                    value + ' %'
                ) : value}
            </span>
            <Progress barStyle={{ backgroundColor: colorStyle }} value={value} />
        </div>
    )
}
